import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { SupportDialogService } from '../services/support-dialog.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.sass'],
})
export class FooterComponent implements OnInit {
  openSupport(): void {}
  language: any = environment.appLanguage;
  isPillar: Boolean = false
  isEboni: Boolean = false
  isRoche: Boolean = false
  isDepsol: Boolean = false
 
  constructor(private dialogService: SupportDialogService) {
    console.log("FOOTER COMPONENT: what is the instance name? ", environment.name)
    this.isPillar = environment.appName === "The Pillar Spot" ? true : false
    this.isEboni = environment.appName === "Eboni Spot" ? true : false
    this.isRoche = environment.name === "cancerdiagnosticeducation" ? true : false
    this.isDepsol = environment.name === "depsolstaging" ? true : false
    // this.isRoche = environment.name === "cancerdiagnosticeducationstaging" ? true : false  // testing staging only
  }
  openSupportDialog(): void {
    console.log('openSupportDialog')
    const dialogOptions = {
      title: 'Modal Support Request',
      panelClass: 'supportDialog'
    }
    this.dialogService.open(dialogOptions)
    this.dialogService.confirmed().subscribe((confirmed) => {})
  }
  ngOnInit(): void {}
}
